import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import SearchByDossierSimpleForm from '../../components/search/SearchByDossierSimpleForm'
import { translate } from 'react-polyglot'
import { fetchDossierSubTypes, fetchSearchDossierSubType } from '../../actions/combos/combos'
import { fetchDossiersSimple, fetchDossiersSimpleDownload, setFilters, setHideFilters } from '../../actions/search/search'
import { openModal } from '../../actions/common'

export function mapStateToProps (state) {
  return {
    ...state.search,
    combos: {
      dossierSubtypesCombo: state.combos.dossierSubTypesCombo,
      searchDossierSubtypesCombo: state.combos.searchDossierSubtypesCombo
    }
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchDossierSubTypes,
      fetchSearchDossierSubType,
      fetchDossiersSimple,
      fetchDossiersSimpleDownload,
      setFilters,
      openModal,
      setHideFilters
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(SearchByDossierSimpleForm))
